export const environment = {
  isDevelopment: () => document.body.dataset.env === 'development'
}
